# for "pure" helper functions. ex. those not requiring imports

# when displaying score instead of age, the score is the age scaled
export SCORE_MULTIPLIER = 10

# helper for handling number formatting
export format_number = (number, maxDigits) ->
  locale = window.app?.browserLocale || 'en'

  if window.app?.supportsToLocaleString()
    return number.toLocaleString(locale, { style: 'decimal', maximumFractionDigits: maxDigits})
  else
    return number.toFixed(maxDigits)

# helper for getting css variables (which is needlessly complicated)
export getCSSVariable = (varName) ->
  window.getComputedStyle(document.documentElement).getPropertyValue(varName)

export setCSSVariable = (varName, value) ->
  document.documentElement.style.setProperty(varName, value)

